import { useReducer } from 'react';
import Profile from '../../pages/profile/Profile';
import reducer from './profile-left-panel-reducer';
import { MdEdit } from 'react-icons/md';
import omegaGreen from './../../images/omega-green.svg';
import alphaGreen from './../../images/alpha-green.svg';
import styles from './ProfileLeftPanel.module.scss';
import { useAppContext } from '../../app-context';

const initialState = {};
const ProfileLeftPanel = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { profileData } = useAppContext();
  return (
    <main className={styles.profileLeftPanel}>
      <article className={styles.profileEdit}>
        <img
          className={styles.profileImg}
          src={profileData.imgUrl}
          alt={profileData.name}
        />
        {/* TO-DO, implement this in profile edit screen <MdEdit className={styles.editIcn} />  */}
      </article>
      <article className={styles.profileInfo}>
        <h3>
          {profileData.firstName} {profileData.lastName}
          <img
            className={styles.omega}
            src={profileData.type === 'alpha' ? alphaGreen : omegaGreen}
          />
        </h3>
        <p>{profileData.university}</p>
        <p>GRE: {profileData.gre}</p>
        <p>TOELF: {profileData.toefl}</p>
        <p>Undergrad: {profileData.undergrad}</p>
        <p>CGPA: {profileData.undergradGPA}</p>
        <p>Research papers: {profileData.researchPapers.length}</p>
        <p>Work Experience: {profileData.workExperience}</p>
      </article>
      <article className={styles.contactInfo}>
        <h3>Contact info:</h3>
        <p>{profileData.phone}</p>
        <p>{profileData.email}</p>
      </article>
    </main>
  );
};

export default ProfileLeftPanel;
